<template>
  <div v-if="!isTs" class="wrapper">
    <!-- 基金名 -->
    <div class="fund-name">{{basicInfo.fundName}}</div>
    <!-- 基金副标题：代码、标签 -->
    <div class="sub-row">
      <div class="fund-code">{{ basicInfo.fundCode }}</div>
      <!-- 后端基金代码 -->
      <div v-if="!$isEmpty(basicInfo.backCode)" class="back-code"
        >{{`后端 ${basicInfo.backCode}`}}</div>
      <span class="fund-tag"
        v-for="(item, index) in headerTags" :key="`tag-${index}`"
        @click="$goFundApp">{{item.tag}}</span>
      <span v-if="!$isEmpty(etfMarketInfo.tradeStatus)"
        class="etf-status-tag">{{etfMarketInfo.tradeStatus}}</span>
    </div>
    <!-- 行情 -->
    <normal-market-header v-if="fundType === 'detail'" :basicInfo="basicInfo" />
    <currency-market-header v-if="fundType === 'currency'" :basic-info="basicInfo" />
    <etf-market-header v-if="fundType === 'ETF' && !$isEmpty(etfMarketInfo)"
      :market-info="etfMarketInfo" />
    <new-fund-market-header v-if="fundType === 'new-fund'"
      :basic-info="basicInfo" :new-fund-status="newFundStatus" />
    <!-- 榜单入口 -->
    <div v-if="fundType === 'detail' && !$isEmpty(bigDataListInfo)"
      class="rank-box"
      @click="$goFundApp">
      <img :src="rankImg" class="rank-img" />
      <span class="rank-title">{{bigDataListInfo.BUSINESSTEXT}}</span>
      <img :src="arrow" class="rank-arrow" />
    </div>
    <!-- 诊断 -->
    <div v-if="!basicInfo.isETF && !basicInfo.isNewFund"
      @click="$goFundApp"
      class="diagnose">诊断</div>
    <!-- 新发基金标签 -->
    <div v-if="fundType === 'new-fund' && !$isEmpty(newFundStatus.statusText)" class="new-fund-tag"
      >{{newFundStatus.statusText}}</div>
  </div>
  <div v-else class="wrapper">
    <!-- 基金名 -->
    <div class="fund-name">{{basicInfo.fundName}}</div>
    <div class="ts-date">{{`已于${basicInfo.delListedDate}终止`}}</div>
  </div>
</template>

<script>
// import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import { mapState } from 'vuex';
import CurrencyMarketHeader from '../../../components/FundHeaderMarket/CurrencyMarketHeader.vue';
import EtfMarketHeader from '../../../components/FundHeaderMarket/EtfMarketHeader.vue';
import NewFundMarketHeader from '../../../components/FundHeaderMarket/NewFundMarketHeader.vue';
import NormalMarketHeader from '../../../components/FundHeaderMarket/NormalMarketHeader.vue';
import formatter from '../../../utils/detail-format';

export default {

  name: 'fund-basic-header',

  components: {
    NormalMarketHeader,
    CurrencyMarketHeader,
    EtfMarketHeader,
    NewFundMarketHeader,
  },

  props: {
    fundType: {
      type: String,
      default: '',
    },
    fundCode: {
      type: String,
      default: '',
    },
    basicInfo: {
      type: Object,
    },
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      rankImg: 'https://j5.dfcfw.com/sc/image/202209/20220905070324.png',
      arrow: 'https://j5.dfcfw.com/sc/image/202209/20220905070354.png',
      etfMarketInfo: {}, // 场内行情数据
      newFundStatus: {}, // 新发基金信息
    };
  },

  computed: {
    ...mapState('detail1', ['fundDetail1']),
    isTs() { // 是否退市基金
      return this.basicInfo?.isDelListedFund;
    },
    headerTags() {
      const headerTags = this.fundDetail1?.headerTags || [];
      return this.fundType === 'ETF' ? ['场内基金', '万2.5费率', '实时成交'].map((item) => ({
        tag: item,
      })) : headerTags;
    },

    bigDataListInfo() { // 大数据榜单入口信息
      const { bigDataListTag } = this.fundDetail1 || {};
      if (!this.$isEmpty(bigDataListTag) && !this.$isEmpty(bigDataListTag.BUSINESSTEXT)) {
        return bigDataListTag;
      }
      return {};
    },
  },

  watch: {
    detailInfo: {
      handler() {
        if (this.fundType === 'ETF') {
          this.getStockMarketInfo();
        }
      },
    },
    basicInfo: {
      immediate: true,
      deep: true,
      handler() {
        if (!this.$isEmpty(this.basicInfo)) {
          let status = '';
          const { startTime, endTime } = this.basicInfo;
          if (this.$isEmpty(startTime) || this.$isEmpty(endTime)) {
            this.newFundStatus = {
              status: 'error',
              statusText: '',
            };
            return;
          }
          const start = new Date(startTime.replace(/-/g, '/')).getTime();
          const end = new Date(endTime.replace(/-/g, '/')).getTime();
          const now = new Date().getTime();
          let statusText = '';
          let desc = '';
          if (start - now > 0) {
            statusText = '即将开售';
            desc = '距离开售还有';
            status = 'start';
          } else if (start - now <= 0 && end - now >= 0) {
            statusText = '募集中';
            desc = '距离认购结束还剩';
            status = 'buying';
          } else if (end < now) {
            statusText = '募集结束';
            status = 'end';
            desc = `${endTime}募集结束`;
          } else {
            status = 'error';
            statusText = '';
          }
          this.newFundStatus = {
            statusText,
            desc,
            status,
          };
        }
      },
    },
  },

  methods: {

    async getStockMarketInfo() {
      const newMarketCode = this.detailInfo?.newMarketCode;
      if (this.$isEmpty(this.fundCode) || this.$isEmpty(newMarketCode)) return;
      const stokeParams = {
        secids: `${this.detailInfo.newMarketCode}.${this.fundCode}`,
        fields: 'f12,f14,f441',
        dpt: 'jj.hqpush',
        pn: 1,
        pz: 1,
      };
      const [res, stokeRes] = await Promise.all([
        this.$http.useRequests('StokeApi.getETFFundMarket', {
          FCODE: `${newMarketCode}.${this.fundCode}`,
        }).catch((err) => { console.log('getStockMarketInfo ERR', err); }),
        this.$http.useRequests('StokeApi.getMarketData', stokeParams)
          .catch(() => ({})),
      ]);
      let lastValuation = stokeRes?.data?.diff?.[0]?.f441 || '--';
      if (this.$isEmpty(lastValuation)) {
        const valRes = await this.$http.useRequests('FundComApi.getValuationLast', { FCODES: this.fundCode })
          .catch(() => {});
        console.log('===> valRes', valRes);
        lastValuation = valRes?.data?.[0].GSZ || '--';
      }
      this.etfMarketInfo = formatter.formatStockMarket(
        res?.data, this.basicInfo?.netValue, lastValuation,
      );
      console.log('====> getStockMarketInfo', this.etfMarketInfo, stokeRes);
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  background-color: #ffffff;
  border-radius: 10px;
  width: 100%;
  padding: 38px 24px 26px;
  box-sizing: border-box;
  position: relative;
  margin-bottom: 24px;
  .new-fund-tag {
    background: rgba(250, 89, 20, 0.1);
    border-radius: 0 12px 0 12px;
    font-family: PingFangSC-Medium;
    font-size: 24px;
    color: #FA5914;
    text-align: right;
    position: absolute;
    right: 0;
    top: 0;
    padding: 9px 28px;
  }
}
.fund-name {
  max-width: 550px;
  font-family: PingFangSC-Medium;
  font-size: 38px;
  color: #000000;
  font-weight: bold;
}
.sub-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 24px;
  line-height: 24px;
  .back-code {
    padding: 6px 10px;
    margin-left: 10px;
    border-radius: 4px;
    line-height: 24px;
    background-image: url(https://j5.dfcfw.com/sc/image/202112/20211228050402.png);
    background-size: 100%;
    font-family: DINAlternate-Bold;
    font-size: 24px;
    text-align: center;
    color: #999999;
    margin-top: 12px;
  }
}
.fund-code {
  font-family: DINAlternate-Bold;
  font-size: 28px;
  color: #999999;
  margin-top: 12px;
}
.fund-tag {
  white-space: nowrap;
  border-radius: 4px;
  padding: 6px 10px;
  margin-left: 10px;
  font-family: PingFangSC-Regular;
  font-size: 24px;
  text-align: center;
  margin-top: 12px;
  color: #52a2ff;
  background-color: rgba(82, 162, 255, 0.1);
}
.etf-status-tag {
  border-radius: 4px;
  padding: 6px 10px;
  margin-left: 10px;
  font-family: PingFangSC-Regular;
  font-size: 24px;
  text-align: center;
  margin-top: 12px;
  color: #666666;
  background: rgba(102, 102, 102, 0.1);
}
.rank-box {
  margin-top: 12px;
  background-image: url(https://j5.dfcfw.com/sc/image/202209/20220908070100.png);
  background-size: 100% 42px;
  border-radius: 12px;
  width: 100%;
  height: 42px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.rank-img {
  width: 142px;
  height: 42px;
}
.diagnose {
  background: rgba(0, 138, 255, 0.1);
  border-radius: 100px 0 0 100px;
  padding: 9px 28px;
  color: #008AFF;
  font-size: 24px;
  line-height: 24px;
  font-weight: 500;
  position: absolute;
  right: 0;
  top: 38px
}
.rank-title {
  font-size: 26px;
  color: #955E3C;
  line-height: 42px;
  font-weight: 400;
  flex: 1;
  margin-right: 16px;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
}
.rank-arrow {
  width: 10px;
  height: 18px;
  margin-right: 16px;
}
.ts-date {
  font-size: 38px;
  color: #999999;
  margin-top: 40px;
}
</style>
